import React, { createContext, useReducer, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { initialState, reducer } from './store/reducer';
import axiosInterceptor from './utilities/axiosInterceptor';
import AuthContext from './components/AppAuthContext';

import {
  HomePage,
  Login,
  CreateProject,
  BuildApps,
  ViewPageDataModel,
  ViewProjectDataModel,
  ViewPageFlow,
  ViewProjectFlow,
  EditProject,
  AboutPage,
  ProfilePage,
  DeployPage,
  QualityPage,
  AuthenticationPage
} from './components/index';

export const useAuthContext = () => useContext(createContext());

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || '',
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || '',
  release: `wabli@0.1.0`,
  enabled: process.env.NODE_ENV === 'production'
});

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  axiosInterceptor();
  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/create_project" element={<CreateProject />} />
          <Route path="/build_apps" element={<BuildApps />} />
          <Route path="/view_page_data_model" element={<ViewPageDataModel />} />
          <Route path="/view_project_data_model" element={<ViewProjectDataModel />} />
          <Route path="/view_page_flow" element={<ViewPageFlow />} />
          <Route path="/view_project_flow" element={<ViewProjectFlow />} />
          <Route path="/edit_project" element={<EditProject />} />
          <Route path="/about_page" element={<AboutPage />} />
          <Route path="/profile_page" element={<ProfilePage />} />
          <Route path="/deploy_page" element={<DeployPage />} />
          <Route path="/authentication_page" element={<AuthenticationPage />} />
          <Route path="/server_project_quality" element={<QualityPage />} />
          <Route path="/front_project_quality" element={<QualityPage />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
